import PropTypes from "prop-types";
import { TagRoot, TagLabel, EmptyText } from "./CategoryTagStyled";

/**
 * Inline pill for displaying an AI-assigned document category (e.g.
 * "VA Decision", "Medical Records"). Falls back to a muted "N/A" label
 * when the category is missing, matching legacy behavior so no surface
 * loses information when this component is introduced.
 */
const CategoryTag = ({ category, emptyLabel = "N/A", size = "sm", className }) => {
  if (!category) {
    return <EmptyText>{emptyLabel}</EmptyText>;
  }

  return (
    <TagRoot $size={size} className={className} title={category}>
      <TagLabel>{category}</TagLabel>
    </TagRoot>
  );
};

CategoryTag.propTypes = {
  category: PropTypes.string,
  emptyLabel: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md"]),
  className: PropTypes.string,
};

export default CategoryTag;
